export default "__VITE_ASSET__0681ec54__"